import { createActionsHook } from 'src/lib/sweetState';

import { ListViewStore } from './ListViewStore';

export const useListViewActions = createActionsHook(ListViewStore);
